






































import AjaxErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { BrandRouteResolver } from '@/util/brandRouteResolver'
import { InstanceResolver } from '@/util/instanceResolver'
import { log } from '@/util/log'
import { ClickEvent } from '@ajax/vue/components/templates/item-list/condition/contactlens/view/ConditionSection.vue'
import { FormValue, formValues } from '@ajax/vue/components/templates/item-list/condition/contactlens/view/form-values'
import { TagsService } from '@spa/services/api/tags'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { getAction } from '../common/view/submit'
import { initializeInteraction } from './interaction/initialize'
import { Interaction, notFilledInteraction } from './interaction/interaction'
import ConditionSection from './view/ConditionSection.vue'

@Component({
  components: {
    AjaxErrorDialog,
    ConditionSection,
  },
})
export default class ConditionForContactLens extends Vue {
  submitting: boolean = false
  hasError: boolean = false
  errorMessage: string[] = []
  private interaction: Interaction = notFilledInteraction

  get behavior(): BehaviorConfig {
    return BehaviorConfig.createFromBrand(this.brandEnglishName)
  }

  get formValues(): readonly FormValue[] {
    return formValues(this.interaction, new URLSearchParams(location.search))
  }

  get action(): string {
    return getAction({
      brandEnglishName: this.brandEnglishName,
      instanceResolver: InstanceResolver,
      location,
    })
  }

  async created() {
    try {
      this.interaction = await initializeInteraction({
        tagsService: new TagsService(),
        behavior: this.behavior,
        location,
      })
    } catch (e) {
      this.errorMessage = [
        'エラーが発生しました。',
        '※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。',
      ]
      this.hasError = true
      log.error('[ConditionForContactLens.vue] ABORT TRIGGERED - Setting hasError=true', e)
    }
  }

  onClick({ condition, section }: ClickEvent) {
    this.interaction = this.interaction.toggle(section.name, condition)
  }
  onReset() {
    this.interaction = this.interaction.reset()
  }

  private get brandEnglishName(): string {
    return BrandRouteResolver.resolveBrandFromPathElement(
      this.$route.params.brand_english_name || ''
    )
  }
}
